export default "__VITE_ASSET__BUihNs_5__"